import { ENUM__page_type } from '@/enums/ENUM__page_type';
import { use_slice_search, use_slice_workspace } from '@/hooks/store/use_slices';
import i18n_page_settings_workspace from '@/locales/keys/i18n_page_settings_workspace.json';
import { TABLE__empty } from '@/pages/_base/table/TABLE__empty';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { md } from '@/utils/utils_html';
import { DTO__workspace_child_enity } from '@shared/dto/+workspace/workspace_entity/_database_entity_with_grid2d_permissions/dto_workspace_child_enity';
import { DTOSearchSettings } from '@shared/dto/search/dto_search_settings';
import { useTranslation } from 'react-i18next';
import { WSSharedTableHeader } from '../_base/WSSharedTableHeader';
import { WSSharedTableRow } from '../_base/WSSharedTableRow';

export function WSSharedSearchTable() {
  const { search_history_map } = use_slice_search(['search_history_map']);

  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_SETTINGS_WORKSPACE);
  const { workspace_current } = use_slice_workspace(['workspace_current']);

  /*
   * RENDERS
   */

  function render_rows(searches: DTOSearchSettings[]) {
    return searches.map((search, index) => {
      return <WSSharedTableRow item={search} key={`${search._id}_${index}`} url={ENUM__page_type.BUILD_PATH_SEARCH(search._id)} />;
    });
  }

  function render_table(searches: DTOSearchSettings[]) {
    searches = searches
      .filter(search => search.workspace_id == workspace_current._id)
      .filter(search => search.is_shared)
      .sort(DTO__workspace_child_enity.sort_by_sharing_started_at);

    let out = <></>;

    if (searches.is_empty()) {
      out = <TABLE__empty />;
    } else {
      out = <div className="flex flex-col justify-start items-center h-full w-full ">{render_rows(searches)}</div>;
    }

    return out;
  }

  /*
   * HTML
   */

  return (
    <div className="w-full h-full">
      <div
        className={`${md(
          'h-full w-full overflow-auto',
          ' pt-2 max-h-[25vh]',
        )} mt-3  flex flex-col justify-center items-start  border-b border-component-border  text-page-foreground`}
      >
        <div className="text-xl">{t(i18n_page_settings_workspace.tabs.shared_entities.search_component.title)}</div>

        <WSSharedTableHeader />

        {render_table(Array.from(search_history_map.values()))}
      </div>
    </div>
  );
}
